export default __webpack_public_path__ + "static/download-sign-up-illustration-dark-fe9b731de4be63850ea94b5cc2436c2b.svg";